import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

const editorPick = featuredComics[2];

export default function EditorPick() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide mb-3">
            主编力荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            编辑精选 · 不容错过的韩漫经典
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-xl mx-auto">
            我们的编辑团队每周从数千部作品中甄选出口碑与质量俱佳的优秀漫画
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          <div className="lg:w-1/2">
            <Link
              to={`/comic/${editorPick.slug}`}
              className="block relative rounded-xl overflow-hidden aspect-[4/3] group cursor-pointer"
            >
              <img
                src={editorPick.cover}
                alt={editorPick.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute top-4 left-4 flex items-center gap-2">
                {editorPick.tags.slice(0, 3).map((tag) => (
                  <span key={tag} className="px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium">
                    {tag}
                  </span>
                ))}
              </div>
              <div className="absolute bottom-4 left-4 right-4">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-1">{editorPick.title}</h3>
                <p className="text-sm text-background-200/80 line-clamp-1">{editorPick.author} · {editorPick.views}阅读 · {editorPick.rating}分</p>
              </div>
            </Link>
          </div>

          <div className="lg:w-1/2 flex flex-col gap-4">
            <div className="bg-foreground-900 rounded-xl p-5 md:p-6 flex-1">
              <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-500/20 text-accent-400 text-xs font-medium mb-3">
                编辑推荐语
              </span>
              <h3 className="font-heading text-xl font-bold text-background-50 mb-3">
                {editorPick.title}
                <span className="text-background-400 text-sm font-normal ml-2">{editorPick.altTitle}</span>
              </h3>
              <p className="text-sm text-background-300 leading-relaxed mb-4">
                {editorPick.description}
              </p>
              <div className="flex flex-wrap gap-2">
                {editorPick.tags.map((tag) => (
                  <span key={tag} className="px-3 py-1 rounded-full bg-background-800 text-background-300 text-xs">
                    #{tag}
                  </span>
                ))}
              </div>
              <Link
                to={`/comic/${editorPick.slug}`}
                className="inline-flex items-center gap-2 mt-5 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <span>立即阅读</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {featuredComics.slice(3, 5).map((comic) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.slug}`}
                  className="bg-background-50 rounded-xl p-4 flex items-center gap-3 group cursor-pointer hover:bg-background-200/50 transition-colors"
                >
                  <div className="w-16 h-20 rounded-lg overflow-hidden flex-shrink-0">
                    <img src={comic.cover} alt={comic.title} className="w-full h-full object-cover object-top" loading="lazy" />
                  </div>
                  <div className="min-w-0">
                    <h4 className="font-heading text-sm font-bold text-foreground-950 line-clamp-1">{comic.title}</h4>
                    <p className="text-xs text-foreground-500 mt-0.5">{comic.chapters}话 · {comic.rating}分</p>
                    <span className="inline-block mt-1 px-1.5 py-0.5 rounded text-[10px] bg-accent-100 text-accent-700 font-medium">
                      {comic.category === 'romance' ? '恋爱' : '动作'}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}